import { render, staticRenderFns } from "./ItemCategoryBioPanel.vue?vue&type=template&id=a9b90d08&"
import script from "./ItemCategoryBioPanel.vue?vue&type=script&lang=js&"
export * from "./ItemCategoryBioPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports